import { Box, Cog6ToothIcon, Flex, IconButton, Panel, Text } from 'components'
import { useWorkspace } from 'components/providers'
import { useEffect } from 'react'
import { forceLight, useBreakpoint, useDisclosure, useEntevatePermission } from 'utils'
import {
  ManageSubscriptionDrawer,
  MultipleLimitsWarning,
  SubscriptionInfo,
  SubscriptionLimitPanels,
  SubscriptionResourceUpsell,
} from '../components/subscription'

export default function SubscriptionPage() {
  const breakpoint = useBreakpoint()
  const [entevatePermission] = useEntevatePermission()
  const { subscription, status } = useWorkspace()
  const adminDisclosure = useDisclosure()

  useEffect(() => {
    if (status !== 'success') return
    if (!subscription && entevatePermission === 'entevate') adminDisclosure.onOpen()
  }, [subscription, status, entevatePermission])

  const Container = breakpoint > 1 ? Panel : Box

  return (
    <Box overflow="auto" p={breakpoint < 2 ? 4 : 0} pb={3} pr={5}>
      <Flex alignSelf="stretch" justifyContent="space-between" alignItems="center">
        <Text textStyle="h3" pt={2}>
          Subscription
        </Text>
        {entevatePermission === 'entevate' && (
          <IconButton
            aria-label="Manage Button"
            icon={<Cog6ToothIcon />}
            onClick={adminDisclosure.onOpen}
          />
        )}
      </Flex>

      <Container mt={5} p={{ base: 0, md: 10 }}>
        <Box {...forceLight} display="flex" flexDirection="column" gap={5}>
          <SubscriptionInfo />
          <MultipleLimitsWarning />
          <SubscriptionLimitPanels />
          <SubscriptionResourceUpsell />
        </Box>
      </Container>

      <ManageSubscriptionDrawer {...adminDisclosure} />
    </Box>
  )
}
